import { useCallback, useSyncExternalStore } from 'react';
import { useUser } from '../context/UserContext';
import {
  readUserDashboardPreferences,
  subscribeToDashboardPreferences,
  updateUserDashboardPreferences,
} from '../helpers/dashboardPreferencesStorage';

const readIsChartVisible = (userId?: string): boolean =>
  readUserDashboardPreferences(userId).chartVisible !== false;

const readIsLastSevenDays = (userId?: string): boolean =>
  readUserDashboardPreferences(userId).lastSevenDays !== false;

export const useDashboardChartVisibility = () => {
  const { user } = useUser();
  const userId = user?.id;

  const isChartVisible = useSyncExternalStore(subscribeToDashboardPreferences, () =>
    readIsChartVisible(userId),
  );
  const isLastSevenDays = useSyncExternalStore(subscribeToDashboardPreferences, () =>
    readIsLastSevenDays(userId),
  );

  const toggleChartVisibility = useCallback(() => {
    if (!userId) return;
    updateUserDashboardPreferences(userId, (preferences) => ({
      ...preferences,
      chartVisible: preferences.chartVisible === false,
    }));
  }, [userId]);

  const setLastSevenDays = useCallback(
    (lastSevenDays: boolean) => {
      if (!userId) return;
      updateUserDashboardPreferences(userId, (preferences) =>
        preferences.lastSevenDays === lastSevenDays
          ? preferences
          : { ...preferences, lastSevenDays },
      );
    },
    [userId],
  );

  return { isChartVisible, toggleChartVisibility, isLastSevenDays, setLastSevenDays };
};
